var changedFlag = false;

var outOfStock = false;

var outOfStockLoc = [];

var appLoad = true

var userCity = "";

var PaLocation = ""
var DeLocation = ""

var selectedInv = ""

var fakeCheckbox = false

var selector = "#" + document.querySelector('.ProductForm__Item').getAttribute('aria-controls')
    
window.addEventListener('DOMContentLoaded', () => {
    var originalOptions = []
    

    $.getJSON("https://bullseyesb.online/locations", function(data) {

        let arr = data.locations
        const searchTerms = ['Christiana Mall', 'Capital City Plaza']
        let result = arr.filter(obj => searchTerms.includes(obj.name));

        for (let loc of result) {
            if (loc.province_code == "PA") {
                PaLocation += `<p>${loc.address1} <br> ${loc.city} ${loc.province_code} ${loc.zip} <br> ${loc.country_name}</p>`
            }
            if (loc.province_code == "DE") {
                DeLocation += `<p>${loc.address1} <br> ${loc.city} ${loc.province_code} ${loc.zip} <br> ${loc.country_name}</p>`
            }
        }
    });

    
    var divs = document.querySelector(selector).querySelectorAll("button.u-h6")
    originalOptions = divs

    for (let element of divs) {
        var matches = element.innerHTML.match(/\((.*?)\)/g);
        if (matches) {
            if (matches.includes("(No Box)")) {
                element.innerHTML = element.innerHTML.replace(/\(.*\)|\[.*\]/, '').trim() + " No Box"
            } else {
                element.innerHTML = element.innerHTML.replace(/\(.*\)|\[.*\]/, '').trim()
            }
        }
    }

    for (let element of divs) {
        let count = 0
        for (let em of divs) {
            if (em.innerHTML == element.innerHTML) {
                if (count >= 1) {
                    em.style.display = "none"
                    if (element.getAttribute("hide-positions")) {
                        element.setAttribute("hide-positions", element.getAttribute("hide-positions") + "," + em.getAttribute("data-value"))
                    } else {
                        element.setAttribute("hide-positions", em.getAttribute("data-value"))
                    }
                }
                count++
            }
        }
    }

    var checkAvail = document.querySelector(selector).querySelectorAll("button.u-h6")

    for (let element of checkAvail) {
        let selected = element.getAttribute("data-value")
        var gv = getVariant(selected.replace(/ /g, ''))
        let allhidden = element.getAttribute("hide-positions")
        if (allhidden) {
            if ($(gv).attr('disabled')) {
                let myArray = allhidden.split(",");
                let count = 0;
                for (let opt of myArray) {
                    var getMatch = opt.match(/\((.*?)\)/g);
                    let gvh = getVariant(opt.replace(/ /g, ''))
                    if ($(gvh).attr('disabled')) {
                        count++
                    }
                }
                if (myArray.length == count) {
                    $(element).hide()
                }
            }
        } else {
            if ($(gv).attr('disabled')) {
                $(element).hide()
            }
        }
    }
    
    selectedInv = document.querySelector(selector).querySelector("button.u-h6.is-selected")
    
    showLocations(selectedInv)
    
    setTimeout(function(){
        selectedVal()
    },1000)

    $(selector + ' button.u-h6').click(function(e) {
        let b6 = this
        selectedInv = b6
        if(e.hasOwnProperty("originalEvent")){
            if(e.originalEvent.isTrusted){
                changedFlag = true
            }    
        }
        showLocations(b6)    
    })


    $('body').on('click', '.store-availability-information__link', function() {
        modelVariant()
    })
    
    $(".locations input").click(function(e) {
        if(e.originalEvent){
            fakeCheckbox = false
        }else{
            fakeCheckbox = true
        }
    })

    $(".locations input").change(function(e) {
        if(fakeCheckbox == false){
            let t = this
            selectV($(t).val())
        }
    })
});

var possibleOthers = [
                        "",
                        "(AH)",
                        "(Ben)",
                        "(DO)",
                        "(HS)",
                        "(TB)",
                        "(MJ)",
                        "(LJ)",
                        "(CG)",
                        "(AM)",
                        "(CJ)",
                        "(Smoke)",
                        "(Smokey)",
                        "(Swervo)",
                        "(JL)",
                        "(ZD)",
                        "(Laura)",
                        "(Roman)",
                        "(MM)",
                        "(JO)",
                        "(AV)",
                        "(JR)",
                        "(CR)",
                        "(IB)",
                        "(DG)",
                        "(Christiana)",
                        "(Labar)",
                        "(Joe)",
                        "(Krauss)",
                        "(Nash)",
                        "(Strafford)",
                        "(Adam)",
                        "(Ryan)",
                        "(Nash)"
                    ];

function selectV(loc){
    let ck = document.querySelector(".ProductForm__SelectedValue").innerHTML
    
    if (loc == "PA") {
        let fv = document.querySelector(`button[data-value='${ck.replace(/\(.*\)|\[.*\]/,'')+"(PA)"}']`)

        if (!fv) {
            fv = document.querySelector(`button[data-value='${ck.replace(/\(.*\)|\[.*\]/,'')+" (PA)"}']`)
        }
        
        if (fv) {
            fv.click()
            
            setTimeout(function(){
                if(!$(".store-availability-information svg path").attr("stroke-linecap")){
                    getInventory("(PA)",ck.replace(/\(.*\)|\[.*\]/,''))
                }
            },200)
            
        }else{
            for(let i of possibleOthers){
                let f = getVariant(`${ck.replace(/\(.*\)|\[.*\]/,'')+"(PA)"+i}`)
                if(f){
                    if(!$(f).attr("disabled")){
                        fv = document.querySelector(`button[data-value='${ck.replace(/\(.*\)|\[.*\]/,'')+" (PA) "+i}']`)
                        fv.click()
                    }
                }
            }
        }
        
        viewModel("Capital City Plaza", PaLocation)
    }
    if (loc == "DE") {

        let fv = document.querySelector(`button[data-value='${ck.replace(/\(.*\)|\[.*\]/,'')+"(DE)"}']`)

        if (!fv) {
            fv = document.querySelector(`button[data-value='${ck.replace(/\(.*\)|\[.*\]/,'')+" (DE)"}']`)
        }

        if (fv) {
            fv.click()
            
            setTimeout(function(){
                if(!$(".store-availability-information svg path").attr("stroke-linecap")){
                    getInventory("(DE)",ck.replace(/\(.*\)|\[.*\]/,''))
                }
            },200)
            
        }else{
            for(let i of possibleOthers){
                let f = getVariant(`${ck.replace(/\(.*\)|\[.*\]/,'')+"(DE)"+i}`)
                if(f){
                    if(!$(f).attr("disabled")){
                        fv = document.querySelector(`button[data-value='${ck.replace(/\(.*\)|\[.*\]/,'')+" (DE) "+i}']`)
                        fv.click()
                    }
                }
            }
        }
        viewModel("Christiana Mall", DeLocation)
    }
    
    if ($(".ProductForm__SelectedValue")) {
        let elementval = document.querySelector(".ProductForm__SelectedValue")
        var matches = elementval.innerHTML.match(/\((.*?)\)/g);

        if (matches) {
            if (matches.includes("(No Box)")) {
                document.querySelector(".ProductForm__SelectedValue").textContent = document.querySelector(".ProductForm__SelectedValue").innerHTML.replace(/\(.*\)|\[.*\]/, '').trim() + " No Box"
            } else {
                document.querySelector(".ProductForm__SelectedValue").textContent = document.querySelector(".ProductForm__SelectedValue").innerHTML.replace(/\(.*\)|\[.*\]/, '').trim()
            }
        }
    }
}

function viewModel(text, loc) {
    $(".store-availability-information__title strong").text(text)
    waitForElementToDisplay(".store-availabilities-modal", function() {
        $("p.store-availability-information__title strong").text(text)
        if (loc != "") {
            $('.store-availability-list__contact').html(loc)
        }
    }, 1000, 15000);
}

function modelVariant() {
    let element = document.querySelectorAll('.store-availabilities-modal__variant-title')
    for (let elm of element) {
        if (elm) {
            var matches = $(elm).html().match(/\((.*?)\)/g);
            if (matches) {
                if (matches.includes("(No Box)")) {
                    $(elm).html($(elm).html().replace(/\(.*\)|\[.*\]/, '').trim() + " No Box")
                } else {
                    $(elm).html($(elm).html().replace(/\(.*\)|\[.*\]/, '').trim())
                }
            }
        }
    }
}

function showLocations(div) {
    outOfStockLoc.length = 0
    outOfStock = false
    $('.locations').show()
    $('.locations #PA').show()
    $('.locations #DE').show()
    $('.locations #PA span').hide()
    $('.locations #DE span').hide()
    
    $('#PA input').prop("disabled", true);
    $('#DE input').prop("disabled", true);
    
    setTimeout(function() {
        let selected = div.getAttribute("data-value")
        let allhidden = div.getAttribute("hide-positions")
        let found = []
        let sfound = []
        if (allhidden) {
            let myArray = allhidden.split(",");
            myArray.push(selected)
            let paFlag = false
            for (let opt of myArray) {
                var getMatch = opt.match(/\((.*?)\)/g);
                if (getMatch) {
                        if (getMatch.includes("(DE)")) {
                            found.push(opt)
                            showSelected(opt, "DE")
                        }
                        if (getMatch.includes("(PA)")) {
                            found.push(opt)
                            if(!paFlag || $('#PA input').prop("disabled")){
                                paFlag = true
                                showSelected(opt, "PA")    
                            }
                        }    
                }
            }
        } else {
            $('.locations #PA span').show()
            $('.locations #DE span').show()
            var getMatch = selected.match(/\((.*?)\)/g);
            if (getMatch) {
                if (getMatch.includes("(DE)")) {
                    found.push(selected)
                    showSelected(selected, "DE")
                }
                if (getMatch.includes("(PA)")) {
                    found.push(selected)
                    showSelected(selected, "PA")
                }
            }
        }
        
        // let q = selected.replace(/\(.*\)|\[.*\]/, '').trim()
        // let qq = document.querySelectorAll("option")
        
        // console.log(selected)
        // console.log(qq)
        
        // for(let op of qq){
        //     let ops = op.innerHTML.split("-")
        //     if(ops.length > 2){
        //         ops = op.innerHTML.match(/[^-]+(\-[^-]+)?/g)
        //         // var str = op.innerHTML,
        //         // delimiter = '-',
        //         // start = 1,
        //         // tokens = str.split(delimiter);
                
        //         // ops = [tokens.slice(0, start), tokens.slice(start)].map(function(item) {return item.join(delimiter);})
        //     }
        //     // console.log(ops)
        //     for(let opp of ops){
        //         // console.log("--------------------")
        //         // console.log(opp.replace(/ /g, ''))
        //         // console.log(q+"(PA)")
        //         // console.log("--------------------")
        //         if(opp.replace(/ /g, '') === (q+"(PA)")){
        //             if($(op).attr("disabled")){
        //                 $('#PA input').prop("disabled", true);
        //                 outOfStock = true
        //                 outOfStockLoc.push("PA")
        //                 $("#PA span").show()
        //             }else{
        //                 $('#PA input').prop("disabled", false);
        //                 $("#PA span").hide()
        //             }
        //         }
        //         if(opp.replace(/ /g, '') === (q+"(DE)")){
        //             // console.log(op)
        //             if($(op).attr("disabled")){
        //                 $('#DE input').prop("disabled", true);
        //                 outOfStock = true
        //                 outOfStockLoc.push("DE")
        //                 $("#DE span").show()
        //             }else{
        //                 $('#DE input').prop("disabled", false);
        //                 $("#DE span").hide()
        //             }
        //         }
        //     }
        // }
        
        var invenCheck = ""
        
        if(selected.includes("(PA)")){
            invenCheck = "DE"
            if($('#DE input').prop("disabled")){
                verifyInventory("(DE)",selected)
            }
        }else{
            invenCheck = "PA"
            if($('#PA input').prop("disabled")){
                verifyInventory("(PA)",selected)
            }
        }
    }, 100);
    setTimeout(selectedVal, 200)
}

function verifyInventory(type,selected){
    let found = false
    for(let i of possibleOthers){
        let f = getVariant((`${selected.replace(/\(.*\)|\[.*\]/,'')+type+i}`).replace(/ /g, ''))
        if(f){
            if(!$(f).attr("disabled")){
                found = true
                $(`#${type.replace(/[^a-zA-Z0-9 ]/g, '')} input`).prop("disabled", false);
                $(`#${type.replace(/[^a-zA-Z0-9 ]/g, '')} span`).hide()
            }
        }
    }
    if(!found){
        $(`#${type.replace(/[^a-zA-Z0-9 ]/g, '')} input`).prop("disabled", true);
        $(`#${type.replace(/[^a-zA-Z0-9 ]/g, '')} span`).show()
    }
}

function getInventory(type,selected){
    let found = false
    for(let i of possibleOthers){
        let f = getVariant((`${selected+type+i}`).replace(/ /g, ''))
        
        if(f){
            if(!$(f).attr("disabled")){
                found = true
                let single = false
                if (f) {
                    var ii = getNodeIndex(f)
                } else {
                    var ii = 0
                    single = true
                }
                
                let sv = document.querySelectorAll("button.Custom")[ii]
    
                sv.click()
            }
        }
    }
}

function showSelected(opt, type) {
    let v = getVariant(opt.replace(/ /g, ''))
    let single = false
    if (v) {
        var i = getNodeIndex(v)
    } else {
        var i = 0
        single = true
    }
    let sv = document.querySelectorAll("button.Custom")[i]
    
    if ($(v).attr("disabled")) {
        $(`.locations #${type} span`).show()
        $(`#${type} input`).attr("disabled", true)
    } else {
        $(`#${type} input`).attr("disabled", false)
        $(`#${type} span`).hide()
    }
    
    if (!$('.locations').attr("run")) {
        $('.locations').attr("run", true)
    } else {
        if ($("#DE span").is(":hidden") && !$("#PA input").is(":checked")) {
            $(`#DE input`).attr("disabled", false)
            $("#DE span").hide()
        }
        if ($("#PA span").is(":hidden") && !$("#DE input").is(":checked")) {
            $(`#PA input`).attr("disabled", false)
            $("#PA span").hide()
        }
    }
}

function getVariant(selected) {
    var options = document.querySelector("select[title='Variant']").querySelectorAll("option")
    for (let option of options) {
        let getText = option.innerHTML.replace(/ /g, '').split("-")
        let getText2 = option.innerHTML.match(/\((.*?)\)/g)
        if (getText.includes(selected)) {
            return option
        } else {
            let selectedsplit = selected.replace(/ /g, '').split("-")
            if (selectedsplit.length == 2) {
                if (getText.includes(selectedsplit[1])) {
                    return option
                }
            }
        }
    }
}

function getNodeIndex(node) {
    var index = 0;
    while ((node = node.previousSibling)) {
        if (node.nodeType != 3 || !/^\s*$/.test(node.data)) {
            index++;
        }
    }
    return index;
}

function waitForElementToDisplay(selector, callback, checkFrequencyInMs, timeoutInMs) {
    var startTimeInMs = Date.now();
    (function loopSearch() {
        if (document.querySelector(selector) != null) {
            callback();
            return;
        } else {
            setTimeout(function() {
                if (timeoutInMs && Date.now() - startTimeInMs > timeoutInMs)
                    return;
                loopSearch();
            }, checkFrequencyInMs);
        }
    })();
}

function selectedVal() {
    if ($(".ProductForm__SelectedValue")) {
        let elementval = document.querySelector(".ProductForm__SelectedValue")
        var matches = elementval.innerHTML.match(/\((.*?)\)/g);

        if (matches) {
            if (matches.includes("(No Box)")) {
                document.querySelector(".ProductForm__SelectedValue").textContent = document.querySelector(".ProductForm__SelectedValue").innerHTML.replace(/\(.*\)|\[.*\]/, '').trim() + " No Box"
            } else {
                document.querySelector(".ProductForm__SelectedValue").textContent = document.querySelector(".ProductForm__SelectedValue").innerHTML.replace(/\(.*\)|\[.*\]/, '').trim()
            }
        }
    }
    if(userCity != ""){
        getDistance(userCity)    
    }
    
    if (!$("#DE span").is(":hidden") && !$("#PA span").is(":hidden")) {
        waitForElementToDisplay(".store-availability-information__title strong", function() {
            $(".store-availability-information__title").text("Pickup currently unavailable")
        }, 1000, 15000);
    }
}

// calculate distance
function calculateDistance(dest,dest2,org) {
  changedFlag = false
  var origin = org;
  var destination = dest;
  var service = new google.maps.DistanceMatrixService();
  service.getDistanceMatrix(
    {
      origins: [origin],
      destinations: [destination,dest2],
      travelMode: google.maps.TravelMode.DRIVING,
      unitSystem: google.maps.UnitSystem.IMPERIAL, // miles and feet.
      avoidHighways: false,
      avoidTolls: false,
    },
    callbackApi
  );
}
// get distance results
function callbackApi(response, status) {
  console.log(response)
  console.log(status)
  if (status != google.maps.DistanceMatrixStatus.OK) {
      
  } else {
      let allres = response.rows[0].elements
      if(allres[0].status == "ZERO_RESULTS"){
        // console.log("No result for PA")
      }
      if(allres[1].status == "ZERO_RESULTS"){
        // console.log("No result for DE")
      }
      
      if(allres[0].hasOwnProperty("distance") && allres[1].hasOwnProperty("distance")){
          if(allres[0].distance.value > allres[1].distance.value){
              $("#DE").click()
          }else{
              $("#PA").click()
          }
      }
  }
}

function getDistance(current){
    let loc1 = "Capital City Plaza 3401 Hartzdale";
    let loc2 = "604 Christiana Mall";
    
    // if(changedFlag || appLoad){
    //     console.log("changed and appload flag")
    //     appLoad = false
    //     if($("#PA input").prop("disabled") == false && $("#DE input").prop("disabled") == false){
    //         $("#DE input").prop("checked", true).trigger("change")
    //     }else{
    //         $("#PA input").prop("checked", true).trigger("change")
    //     }
    // }
    
    if(changedFlag || appLoad){
        appLoad = false
        if($("#PA input").prop("disabled") == false && $("#DE input").prop("disabled") == false){
            $("#DE input").prop("checked", true).trigger("change")
        }else{
            if($("#PA input").prop("disabled") == false){
                $("#PA input").prop("checked", true).trigger("change")    
            }else{
                if($("#DE input").prop("disabled") == false){
                    $("#DE input").prop("checked", true).trigger("change")
                }
            }
        }
    }
    
    setTimeout(function(){
        if(outOfStock){
            changedFlag = false
        }
        
        if(changedFlag){
            changedFlag = false
            calculateDistance(loc1,loc2,current)
        }    
    },100)
}

 waitForElementToDisplay(".store-availability-information__title strong", function() {
     fetch("https://ipinfo.io/json?token=c970773f317e61").then(
            (response) => response.json()
        ).then(
            (jsonResponse) => {
                console.log(jsonResponse.city)
                changedFlag = true
                userCity = jsonResponse.city
                getDistance(jsonResponse.city)
            }
        )
 }, 1000, 15000);